<template>
  <div class="row-logo">
    <div class="main-width set-position">
      <img :src="logourl" alt>
      <div style="display: inline-block;position: relative;top: 10px;font-size: 18px;">{{slogan}}</div>
      <div class="apps">
        <img src="static/imgs/wechat.jpg" alt width="70px">
        <p>友云采公众号</p>
        <img class="hideimg" src="static/imgs/supplier.png" alt width="70px">
        <p class="hideimg">供应商App</p>
        <img class="hideimg" src="static/imgs/purchaser.png" alt width="70px">
        <p class="hideimg">采购商App</p>
      </div>
      <!-- <div style="float: right; margin-top: 55px;margin-right: 130px;">
        <span class="row-logo-right2">如需业务帮助，请咨询联系业务人员. </span> <br>
        <span class="row-logo-right2">电话：020-32318100</span>
      </div>-->

      <!--搜索框-->
      <div class="input-group pull-right hidden">
        <input type="text" class="form-control" placeholder="搜索商机/物资">
        <span class="input-group-btn">
          <button class="btn btn-default" type="button">
            <img src="static/imgs/search.png">
          </button>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { apiLinks } from 'src/api/links.js'
export default {
  data () {
    return {
      slogan: apiLinks.slogan,
      logourl: apiLinks.logourl
    }
  }
}
</script>
<style>
.hideimg {
  display: none;
}
.apps:hover .hideimg {
  display: block;
}
/*row-logo*/
.row-logo {
  height: 101px;
}

.row-logo > .main-width > img {
  margin-top: 10px;
  height: 90px;
}
.row-logo > div > .input-group {
  width: 300px;
  position: absolute;
  top: 45px;
  right: 0;
}

.apps {
  float: right;
  position: absolute;
  right: 10px;
  top: 0px;
  margin-top: -1px;
  margin-left: 50px;
  width: 92px;
  z-index: 100;
  text-align: center;
  border: 1px solid #eee;
  padding: 3px;
  background-color: white;
  cursor: pointer;
  transition: all 0.1s;
}

.apps p {
  margin: 0;
}

.apps img {
  width: 100%;
}

.apps:hover {
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// G-logo.vue?1bdd61d0